<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-2 pl-4"  *ngIf="dealerList && dealerList.length > 0">
      <div class="relative flmid">
        <div class="flgrow ">
          <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="dealerSelected" ngDefaultControl
            name="dealerDropdown" (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
          </app-dealer-searchbox-dropdown>
        </div>
      </div>
    </div>
    <div class="pl-2 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
      <a class="mr-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()"
          aria-label="Center Align">
          <em class="fas fa-sync fa-lg"></em>
      </a>
      <button type="button" type="reset" *ngIf="userRoleRightsDetails?.canAdd" (click)="onAdd()" class="add-button btn btn-primary" aria-label="Center Align"
        translate>lblAddKeyToLocker</button>
  </div>
  </div>
</div>
<div class="container prel">
  <div> 
    <nav ngbNav #nav="ngbNav" [destroyOnHide]="false" (activeIdChange)="onTabChange($event)">
      <ng-container ngbNavItem="autoKey">
        <button translate ngbNavLink>
          lblAutokey
        </button>
        <ng-template ngbNavContent>
          <div class="card">
            <div class="col-lg-3 col-md-6 col-sm-8" style="margin-top: 1rem;"  *ngIf="userRoleRightsDetails.canAdd">
              <div class="relative flmid">
                <div class="flgrow">
                  <div class="input-group">
                    <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                      [(ngModel)]="pService.searchTerm" autocomplete="off" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary">
                        <em class="fa fa-search"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <div class="table-responsive  max-h232"> 
                <div class="table-responsive">
                  <table class="tablest1">
                    <thead>
                      <tr>
                        <th style="width: 55px" scope="col">#</th>
        
                        <th style="width:10%" scope="col" translate>lblAppointmentType</th>
                        <th style="width: 8%" scope="col" sortable="licensePlate" (sort)="onSort($event)" translate>lblRegNumber
                        </th>
                        <th style="width: 10%" scope="col" translate>lblWoNo</th>
                        <th style="width: 10%" scope="col" translate>lblWoStatus</th>
                        <th style="width:110px" scope="col" translate>lblSource</th>
                        <th style="width: 15%" scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                          lblCustomerName
                        </th>
                        <th style="width: 15%" scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName
                        </th>
                        <th style="width: 5%" scope="col" translate>lblMobileNo</th>
                        <th style="width: 5%" scope="col" translate>lblExchangeMethod</th>
                        <th style="width: 5%" scope="col" translate>lblAssignedLockerDate</th>
                        <th style="width: 5%" scope="col" translate>lblKeyPickUpDate</th>
                        <th style="width: 5%" scope="col" translate>lblKioskName</th>
                        <th style="width: 5%" scope="col" translate>lblLocker</th>
                        <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="autoKeyDetails?.length>0; else load_else">
                        <tr *ngFor="let autoKey of autoKeyDetails; let i=index">
                          <td>{{ autoKey.rowNumber }}</td>
                          <td>
                            {{ autoKey.appointmentType}}
                          </td>
                          <td>
                            <div class="flmid">
                              <div class="licplate LPNo d-flex">
                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                {{autoKey.licensePlate}}
                              </div>
                              <div class="imgWid">
                                <ng-container>
                                  <img af-brand-logo [data-code]="autoKey.brand" data-type="BRAND"
                                    title="Model Name" class="brandicon" />
                                </ng-container>
                              </div>
                            </div>
                          </td>
        
                          <td>
                            <ngb-highlight [result]="autoKey.workorderNumber" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
        
                          <td>
                            <ngb-highlight [result]="autoKey.status" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight class="flmid sourceBox rounded-0 justify-content-center"
                              [result]="autoKey.sourceName" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="autoKey.customerName" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="autoKey.dealerName" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="autoKey.mobile" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            {{autoKey.exchangeMethod}}
                          </td>
                          <td>
                            {{autoKey.lockerAssignDate | date : 'short'}}
                          </td>
                          <td>
                            <ng-container *ngIf="autoKey.cancelled">
                              <label translate>lblCancelled</label>
                            </ng-container>
                            <ng-container *ngIf="!autoKey.cancelled">
                              {{autoKey.pickUpDate | date:'short'}}
                            </ng-container>
                          </td>
                          <td>
                            <ngb-highlight [result]="autoKey.kioskLocation" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="autoKey.lockerId" [term]="pService.searchTerm">
                            </ngb-highlight>
                          </td>
                          <td class="nowrap text-center">
                            <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}" tooltipClass="custom-revert"
                              *ngIf="userRoleRightsDetails.canView" (click)="viewAutoKeyDeatils(autoKey.id)">
                              <em class="far fa-eye fa-lg"></em>
                            </a>
                            <ng-container *ngIf="!autoKey.isKeyPickedUp && userRoleRightsDetails?.canEdit">
                              <span class="ico-div"></span>
                              <ng-container>
                                <a class="btn btn-ico " *ngIf="autoKey.canUnLock ; else disabledEditDelete" ngbTooltip="Unlock"
                                  tooltipClass="custom-revert">
                                  <em class="fas fa-unlock-alt fa-lg" (click)="unlockAutoKey(autoKey.id)"></em>
                                </a>
                                <ng-template #disabledEditDelete>
                                  <a class="btn btn-ico disabled" ngbTooltip="Unlock" tooltipClass="custom-revert">
                                    <em class="fas fa-unlock-alt fa-lg"></em>
                                  </a>
                                </ng-template>
                              </ng-container>
                            </ng-container>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #load_else>
                        <tr>
                          <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between ">
                      <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                        [pageSize]="pService.pageSize" [maxSize]="3">
                      </ngb-pagination>
                      <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                        <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                        </option>
                      </select>
                    </div>
                    <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                      <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                        class="font17 fontnormal" translate>lblResults</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-container ngbNavItem="activeReservationList" *ngIf="shareBox">
        <button ngbNavLink translate>
          lblActiveReservationList
        </button>
        <ng-template ngbNavContent>
          <div class="mt-3">
            <table class="tablest1">
              <thead>
                  <tr>
                      <th style="width: 55px;" scope="col" translate>lblExchangeMethod</th>
                      <th style="width: 17%;" scope="col" translate>lblRegistrationNumber</th>
                      <th style="width: 15%;" scope="col" translate>lblName</th>
                      <th style="width: 15%; cursor: pointer;" scope="col" translate>lblLocation</th>
                      <th style="width: 10%; cursor: pointer;" scope="col" translate >lblLockerNo</th> 
                      <th style="width: 10%;" class="text-center" scope="col" translate>lblStatus</th>
                      <th style="width: 22%;" class="text-center" scope="col" translate>lblOrderId</th>
                  </tr>
              </thead>
              <tbody>
                  <ng-container *ngIf="activeReservationList?.length > 0; else noData">
                  <tr
                      *ngFor="let item of activeReservationList; let i = index" 
                  > 
                      <td>
                          <ngb-highlight [result]="item.exchangeMethod" [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td>
                          <ngb-highlight [result]="item.subscriptionName" [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td>
                          <ngb-highlight [result]="item.reserverFirstName " [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td>
                          <ngb-highlight [result]="item.location" [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td>
                          <ngb-highlight [result]="item.lockerNo" [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td class="text-center">
                        <ngb-highlight [result]="item.status" [term]="searchTerm"></ngb-highlight>
                      </td>
                      <td class="text-center">
                        <ngb-highlight [result]="item.customField1" [term]="searchTerm"></ngb-highlight>
                      </td>
                  </tr>
                  </ng-container>
              </tbody>
              </table>
          
              <ng-template #noData>
              <tr>
                  <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
              </ng-template>
          </div>
        </ng-template>
      </ng-container>
    </nav>

    <div [ngbNavOutlet]="nav"></div>
  </div>
</div>